// src/Login.js
import React, { useState } from 'react';
import { Paper, TextField, Button, Typography, Box } from '@mui/material';
import { API_URL } from './api';

export default function Login({ onLogin }) {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    try {
      const res = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, senha })
      });
      const data = await res.json();
if (res.ok && data.usuario) {
  const usuarioLogado = {
    nome: data.usuario.nome || login,
    login: data.usuario.login || login,
    token: data.usuario.token || '',
    tipo: typeof data.usuario.tipo === 'string'
  ? data.usuario.tipo.split(',').map(t => t.trim()).filter(Boolean)
  : data.usuario.tipo || [],

    processo: data.usuario.processo || ''
  };


  localStorage.setItem('usuario', JSON.stringify(usuarioLogado));
  localStorage.setItem('auth-token', usuarioLogado.token);
  localStorage.setItem('userRole', usuarioLogado.tipo);

  onLogin(usuarioLogado);



const tipos = Array.isArray(usuarioLogado.tipo)
  ? usuarioLogado.tipo.map(t => t.toLowerCase())
  : [usuarioLogado.tipo?.toLowerCase()];

console.log('💥 Tipos no login:', tipos);

const ehANP = tipos.some(t =>
  [
    "pre_impressao", "impressao", "laminadora", "serigrafia",
    "empastadeira", "acopladeira", "onduladeira", "corte_vinco",
    "hotstamping", "destaques", "fechadora", "caixa_rigida",
    "bancada_rigida", "bancada_diversos", "fresa", "qualidade"
  ].includes(t)
);

localStorage.setItem('modoApp', ehANP ? 'anp' : 'principal');


if (ehANP) {
  localStorage.setItem('modoApp', 'anp');
} else {
  localStorage.setItem('modoApp', 'principal');
}



  
} else {
  setErro(data.erro || 'Usuário ou senha incorretos');
}

    } catch (error) {
      setErro('Erro ao conectar ao servidor');
    }
  };

  return (
    <Box display="flex" minHeight="100vh" alignItems="center" justifyContent="center">
      <Paper elevation={4} sx={{ p: 4, minWidth: 320 }}>
        <img
          src="/logo-impram.png"
          alt="Logo Impram"
          style={{
            maxWidth: 180,
            display: 'block',
            margin: '0 auto 24px auto'
          }}
        />
        <form onSubmit={handleSubmit}>
          <TextField
            label="Usuário"
            value={login}
            onChange={e => setLogin(e.target.value)}
            fullWidth
            margin="normal"
            autoFocus
          />
          <TextField
            label="Senha"
            type="password"
            value={senha}
            onChange={e => setSenha(e.target.value)}
            fullWidth
            margin="normal"
          />
          {erro && (
            <Typography color="error" sx={{ mt: 1 }}>{erro}</Typography>
          )}
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{ mt: 2 }}
          >
            Entrar
          </Button>
        </form>
      </Paper>
    </Box>
  );
}
